import qs from 'qs';
import axios from 'axios';
import constants from 'common/constants';
import conf from 'common/config';
import fetch from 'common/services/fetch';
import store from 'common/services/storage';

const req = axios.create({
  timeout: conf.TIME_OUT,
  headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
  responseType: 'json',
});

req.interceptors.request.use(
  (config) => {
    fetch.aesRequest(config);
    return config;
  }, error => Promise.reject(error),
);

req.interceptors.response.use(undefined, (err) => {
  const { config } = err;
  // If config does not exist or the retry option is not set, reject
  if (!config || !config.retry) return Promise.reject(err);

  // Set the variable for keeping track of the retry count
  config.privateRetryCount = config.privateRetryCount || 0;

  // Check if we've maxed out the total number of retries
  if (config.privateRetryCount >= config.retry) {
    // Reject with the error
    return Promise.reject(err);
  }

  // Increase the retry count
  config.privateRetryCount += 1;

  // Create new promise to handle exponential backoff
  const backoff = new Promise((resolve) => {
    setTimeout(() => {
      resolve();
    }, config.retryDelay || 100);
  });

  // Return the promise in which recalls axios to retry the request
  return backoff.then(() => req(config));
});

class TokenManager {
  constructor() {
    this.tokenStorageKey = 'MT_TOKEN';
    this.isRequestingToken = false;

    this.blockedResolveArray = [];
    this.blockedRejectArray = [];
  }

  getStoredToken() {
    return store.get(this.tokenStorageKey);
  }
  /* eslint-disable */
  getToken(currentRequestConfig) {
    const p = new Promise((resolve, reject) => {
      if (this.getStoredToken()) {
        resolve(this.getStoredToken());
        return;
      }

      this.blockedResolveArray.push(resolve);
      this.blockedRejectArray.push(reject);

      if (this.isRequestingToken) {
        return;
      }

      this.isRequestingToken = true;
      const params = {};
      params.partnerId = store.get(store.LOGIN_UID) || '';
      req.defaults.originUri = '/partner/bend/refreshToken';
      req({
        method: 'get',
        url: `${process.env.NODE_ENV === 'production' ? conf.BASE_URI : conf.BASE_URI_TEST}/partner/bend/refreshToken`,
        params,
        retry: 3,
        paramsSerializer(input) {
          return qs.stringify(input);
        },
      }).then((res) => {
        console.log('res: ', res);
        if (res.data.errorCode === constants.errCode.invalidUser) {
          store.remove('LOGIN_UID');
          location.href = '/userLogin';
          return;
        }
        const { data } = res.data;
        store.set(this.tokenStorageKey, data.token);

        this.isRequestingToken = false;
        this.notifyTokenRefreshed();
      }).catch((err) => {
        console.log(err);
        this.notifyTokenFailure();
      });
    });
    return p;
  }

  renewToken(currentRequestConfig) {
    this.clearToken();
    return this.getToken(currentRequestConfig);
  }

  clearToken() {
    if (!this.isRequestingToken) {
      store.remove(this.tokenStorageKey);
    }
  }

  notifyTokenRefreshed() {
    this.blockedResolveArray.forEach(resolve => resolve(this.getStoredToken()));
    this.blockedResolveArray = [];
  }

  // hope we will never call this
  notifyTokenFailure() {
    this.blockedRejectArray.forEach(resolve => resolve());
    this.blockedRejectArray = [];
  }
}

export default new TokenManager();
